<script lang="ts">
  import { Button, Col, Form, FormGroup, Input } from "sveltestrap";
  import { href, Submit } from "../../../../utils/Constant/Constant";
</script>
<Form class="theme-form row">
  <Col xs="12">
    <FormGroup>
      <Input type="text" placeholder="AC Holder name" />
    </FormGroup>
  </Col>
  <Col xs="12">
    <FormGroup>
      <Input type="text" placeholder="Account number" />
    </FormGroup>
  </Col>
  <Col xs="6" class="p-r-0">
    <FormGroup>
      <Input type="select" name="select" value="Select Bank">
        <option>{'Select Bank'}</option>
        <option>{'SBI'}</option>
        <option>{'ICICI'}</option>
        <option>{'KOTAK'}</option>
        <option>{'BOB'}</option>
      </Input>
    </FormGroup>
  </Col>
  <Col xs="6">
    <FormGroup>
      <Input type="text" placeholder="ICFC code" />
    </FormGroup>
  </Col>
  <Col xs="12">
    <FormGroup>
      <Input type="number" placeholder="Enter mobile number" />
    </FormGroup>
  </Col>
  <Col xs="12">
    <FormGroup>
      <Input type="text" placeholder="Other Details" />
    </FormGroup>
  </Col>
  <Col xs="12">
    <Button color="primary" class="btn-block" href={href}>{Submit}</Button>
  </Col>
</Form>